import autobind from 'autobind-decorator';
import { action, computed, observable, toJS } from 'mobx';
import { sortPlayers } from '../../../../../lol/store/util';

@autobind
class VolleyballMatchBroadcastModel {
  constructor(data) {
    this.list = data;
  }

  @observable
  list = [];

  @computed
  get getList() {
    const { list } = this;

    let result = [];

    if (list.length > 0) {
      let prevGroupSequence = null;
      let item = null;
      list.map((value, key) => {
        const isLast = list.length - 1 === key;
        const { viewGroupSequence, playText, score, locationType } = value;
        const eventText = {
          playText: playText,
          locationType: locationType
        };
        if (
          prevGroupSequence !== null &&
          prevGroupSequence === viewGroupSequence
        ) {
          item.eventTexts.push(eventText);
        } else {
          if (item !== null) {
            result.push(item);
            item = null;
          }
          item = {
            groupSequence: viewGroupSequence,
            score: score,
            eventTexts: [eventText]
          };
          prevGroupSequence = viewGroupSequence;
        }

        if (isLast) {
          result.push(item);
        }
      });
    }

    return result;
  }

  @action
  updateBroadcast(data) {
    const check = this.list.some(
      (item) => item.viewGroupSequence === data.viewGroupSequence
    );
    const index = this.list.findIndex((item) => {
      return item.viewGroupSequence === data.viewGroupSequence;
    });
    const deep = [...this.list];

    let spliceIdx = 0;

    if (check) {
      if (index < 0) {
        spliceIdx = 2;
      } else {
        spliceIdx = index;
      }
    } else {
      spliceIdx = 1;
    }

    if (data.viewGroupSequence === 1000) {
      spliceIdx = 0;
    }

    deep.splice(spliceIdx, 0, data);

    this.list = deep;
  }
}

export default VolleyballMatchBroadcastModel;
